export const enum MutationNames {
  updateExercisePrograms = 'EXERCISE_PROGRAM_UPDATE_EXERCISE_PROGRAMS',
  updateChosenExerciseProgramId = 'EXERCISE_PROGRAM_UPDATE_CHOSEN_EXERCISE_PROGRAM',
  updateExerciseProgramSessions = 'EXERCISE_PROGRAM_UPDATE_EXERCISE_PROGRAM_SESSIONS',
  pushNewExerciseProgram = 'EXERCISE_PROGRAM_PUSH_NEW_EXERCISE_PROGRAM',
}

export const enum ActionNames {
  getExercisePrograms = 'EXERCISE_PROGRAM_GET_EXERCISE_PROGRAMS',
  getExerciseProgram = 'EXERCISE_PROGRAM_GET_EXERCISE_PROGRAM',
  patchExerciseProgram = 'EXERCISE_PROGRAM_PATCH_EXERCISE_PROGRAM',
  deleteExerciseProgram = 'EXERCISE_PROGRAM_DELETE_EXERCISE_PROGRAM',
  getExerciseProgramSessions = 'EXERCISE_PROGRAM_GET_EXERCISE_PROGRAM_SESSIONS',
  setChosenExerciseProgramId = 'EXERCISE_PROGRAM_SET_CHOSEN_EXERCISE_PROGRAM',
  postExerciseProgram = 'EXERCISE_PROGRAM_POST_EXERCISE_PROGRAM',
  postExerciseProgramSession = 'EXERCISE_PROGRAM_POST_EXERCISE_PROGRAM_SESSION',
  patchExerciseProgramSession = 'EXERCISE_PROGRAM_PATCH_EXERCISE_PROGRAM_SESSION',
  deleteExerciseProgramSession = 'EXERCISE_PROGRAM_DELETE_EXERCISE_PROGRAM_SESSION',
}

export const enum GetterNames {
  exercisePrograms = 'EXERCISE_PROGRAM_EXERCISE_PROGRAMS',
  chosenExerciseProgramSessions = 'EXERCISE_PROGRAM_CHOSEN_EXERCISE_PROGRAM_SESSIONS',
  chosenExerciseProgram = 'EXERCISE_PROGRAM_CHOSEN_EXERCISE_PROGRAM',
  chosenExerciseProgramId = 'EXERCISE_PROGRAM_CHOSEN_EXERCISE_PROGRAM_ID',
}
